





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel } from "@/models/event";

@Component({})
export class Sport extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;

  get formConfig() {
    return {
      meta: {
        type: {
          label: this.$t("event.fields.type"),
          disabled: this.disabled,
        },
        duration: {
          label: this.$t("event.fields.duration"),
          disabled: this.disabled,
        },
        intensity: {
          label: this.$t("event.fields.intensity"),
          disabled: this.disabled,
        }
      }
    };
  }
}
export default Sport;
